<script>
    import { metaInfo } from "@/core/MetaInfo";
    import TheDetailWrapper from "@auto-admin/components/TheDetailWrapper";

    export default {
        name: "PreorderDetail",
        props: {
            statusPage: String,
        },
        components: { TheDetailWrapper },
        data() {
            return {
                form: {
                    contact: {
                        email: "",
                        name: "",
                        phone: "+7",
                    },
                    createdAt: "",
                    offerId: "",
                    status: "",
                },
                fullName: "",
            };
        },
        computed: {
            isNew() {
                return this.statusPage === "new";
            },
            isView() {
                return this.statusPage === "view";
            },
            isEdit() {
                return this.statusPage === "edit";
            },
            title() {
                let filtered = {
                    new: "Добавить предзаказ",
                    view: "Предзаказ",
                    edit: "Редактировать предзаказ",
                };
                return filtered[this.statusPage];
            },
        },
        mounted() {
            if (this.isEdit || this.isView) {
                this.loadDataForEdited();
            }
        },
        methods: {
            send() {
                if (this.isNew) {
                    // this.handlerForCreate();
                }
                if (this.isEdit) {
                    this.handlerForEdit();
                }
                if (this.isView) {
                    this.handlerForView();
                }
            },
            handlerForView() {
                this.$router.push({
                    name: "PreorderEdit",
                    params: {
                        slug: this.$route.params.slug,
                    },
                });
            },
            handlerForEdit() {
                this.form.contact.phone = this.form.contact.phone.replace("+7", "");
                this.$store.autoAdminApi
                    .editPreorder(this.$route.params.slug, this.form)
                    .then(() => {
                        this.$router.push({
                            name: "PreordersList",
                        });
                    });
            },
            loadDataForEdited() {
                this.$store.autoAdminApi
                    .getPreorder(this.$route.params.slug)
                    .then(({ data }) => {
                        this.form = data;
                        this.form.contact.phone = "+7" + data.contact.phone;
                        this.$store.autoAdminApi.getOffer(data.offerId).then((res) => {
                            this.$store.autoAdminApi
                                .getVersion(res.data.versionId)
                                .then((resIn) => {
                                    let verName = resIn.data.name;
                                    this.$store.autoAdminApi
                                        .getModel(resIn.data.modelId)
                                        .then((resIn) => {
                                            this.fullName = resIn.data.name + " " + verName;
                                        });
                                });
                        });
                    });
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <div class="vendor-detail">
        <the-detail-wrapper
            :title="title"
            type-list="/preorders"
            :current-status="statusPage"
            @handler-submit="send"
        >
            <b-field label="Статус">
                <b-select placeholder="Выбрать статус" v-model="form.status">
                    <option value="new">Новый</option>
                    <option value="in_progress">В процессе</option>
                    <option value="approved">Утвержденный</option>
                    <option value="completed">Завершенный</option>
                </b-select>
            </b-field>
            <b-field label="Модель и Комплектации">
                <b-input v-model.number="fullName" disabled=""></b-input>
            </b-field>
            <b-field label="Имя">
                <b-input v-model="form.contact.name"></b-input>
            </b-field>
            <b-field label="Почта">
                <b-input v-model="form.contact.email"></b-input>
            </b-field>
            <b-field label="Телефон">
                <b-input v-model.number="form.contact.phone"></b-input>
            </b-field>

            <b-field label="Дата создания">
                <b-input v-model.number="form.createdAt"></b-input>
            </b-field>
            <b-field label="Id offer">
                <b-input v-model.number="form.offerId" disabled=""></b-input>
            </b-field>
        </the-detail-wrapper>
    </div>
</template>

<style lang="scss"></style>
